import api from '../lib/utility/api';
import { createApi as createApiRedux } from '@reduxjs/toolkit/query/react';

/**
 * Makes an API request using the specified HTTP method with proper handling for each method
 */
const makeRequest = async (method, url, options = {}) => {
  const { body, params, headers } = options;
  
  switch (method.toLowerCase()) {
    case 'get':
      // GET requests don't have a body, only config with params and headers
      return await api.get(url, { params, headers });
      
    case 'post':
    case 'put':
    case 'patch':
      // POST/PUT/PATCH have body as second parameter and config as third
      return await api[method](url, body, { params, headers });
      
    case 'delete':
      // DELETE requests need body inside the config object
      return await api.delete(url, { 
        params, 
        headers,
        data: body // For DELETE, body goes in data property
      });
      
    default:
      throw new Error(`Unsupported HTTP method: ${method}`);
  }
};

export const axiosBaseQuery =
  () =>
    async ({ url, method, params, body }) => {
      try {
        const result = await makeRequest(method, url, { body, params });
        return { data: result.data };
      } catch (axiosError) {
        const err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    };

export const createApi = (params) => createApiRedux({
  baseQuery: axiosBaseQuery(),
  ...params,
});

